import { DisplayTime } from 'common/display-state/display-time.js';
import { IconWithText } from 'common/icon/icon-with-text.js';
import { IconNameV1 } from 'common/icon/iconV1.js';
import { LinkFactoryReactRouter } from 'common/link/link-react-router.js';
import { Tabs } from 'common/tabs/tabs.js';
import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { useState } from 'react';
import { IModule } from 'redux-state/layout/types.js';

interface IPark {
  name: string;
  issuedAtISO: string;
  wind: string;
  snowfall: number;
  rainfall: number;
  temp: number;
}

interface IParkConditions {
  parks: Array<IPark>;
}

export const ParkConditions = ({ config, isDrawer, modulePath }: IModule<IParkConditions>) => {
  const { parks, link } = config;

  const [activeTab, setActiveTab] = useState(0);

  const renderActiveTabHandler = (index: number) => setActiveTab(index);

  const activePark = parks[activeTab];

  return (
    <Tile dataModule="park-conditions" config={config}>
      <div className="Tile-body">
        <TileBodyHeaderV2 config={config} isDrawer={isDrawer} modulePath={modulePath} />

        <div className="Tab Tab--slim">
          <Tabs
            headerClasses="Tab-item"
            renderActiveTab={renderActiveTabHandler}
            headers={parks.map(({ name }, index) => (
              <p key={index} className="small u-mT-0 u-mB-0">
                {name}
              </p>
            ))}
          />
        </div>

        {activePark && <ParkCondition park={activePark} />}

        {link?.url && (
          <div className="u-flex u-flexJustifyCenter u-flexAlignItemsCenter">
            <LinkFactoryReactRouter className="Link u-linkClean" href={link.url}>
              <small className="u-textBold">{link.label}</small>
            </LinkFactoryReactRouter>
          </div>
        )}
      </div>
    </Tile>
  );
};

const ParkCondition = ({ park }: { park: IPark }) => {
  const { issuedAtISO, wind, snowfall, rainfall, temp } = park;

  return (
    <div className="u-bB-1 u-mB-sm">
      {wind && <IconWithData className="u-pT-sm" icon="wind" label="wind" val={`${wind}km/h`} />}
      {/* icon="snow-dark" */}
      {(snowfall || snowfall === 0) && (
        <IconWithData className="u-pT-sm svg-fill-textSlate" icon="snow" label="snow" val={`${snowfall}cm`} />
      )}
      {(rainfall || rainfall === 0) && (
        <IconWithData className="u-pT-sm" icon="rainfall" label="rainfall" val={`${rainfall}mm`} />
      )}
      {(temp || temp === 0) && (
        <IconWithData className="u-pT-sm" icon="temperature" label="temperature" val={`${temp}°`} />
      )}

      <p className="fineprint u-textGrey u-mT-xs">
        <DisplayTime date={issuedAtISO} />
      </p>
    </div>
  );
};

export const IconWithData = ({
  icon,
  label,
  val,
  className,
}: {
  icon: IconNameV1;
  label: string;
  val: string;
  className?: string;
}) => (
  <div className={className}>
    <IconWithText icon={icon}>
      <h4 className="u-mT-0 u-mB-0">{label}</h4>
      <p className="small u-mT-0 u-mB-0">{val}</p>
    </IconWithText>
  </div>
);
